import { REQUEST } from 'Stores'
import { GET_PAYMENT } from './constants'

export function getPaymentList(payload) {
  return {
    type: REQUEST(GET_PAYMENT),
    payload
  }
}
